import * as commonScripts from '../common'
const cmpContactContent = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)
    const mainImage = _.component.querySelector('.cmp-contact-content__image')
    const cmpParallaxMain = _.component.querySelector('.cmp-contact-content__image .cmp-parallax__main')
    const rightCol = _.component.querySelector('.cmp-contact-content__right')
    const leftCol = _.component.querySelector('.cmp-contact-content__left')
    const submitBtn = _.component.querySelector('.contact-standard-element .form-submit-btn')
    var contactStandardElement = _.component.querySelector('.contact-us-form .contact-standard-element');

    if (mainImage && rightCol) {
      function setSize () {
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth
        const newImageHeight = (leftCol.offsetHeight - rightCol.offsetHeight)
        if (viewportWidth >= 1024) {
          if(submitBtn !== null && contactStandardElement.style.display != 'none'){            
            mainImage.setAttribute('style', 'top: -' + (newImageHeight) + 'px')
            cmpParallaxMain.setAttribute('style', 'height: ' + (newImageHeight) + 'px; margin-bottom: -' + (newImageHeight) + 'px')
          }
          else{
            mainImage.setAttribute('style', 'top: -' + (newImageHeight) + 'px')
            _.component.setAttribute('style', 'margin-bottom: -' + (newImageHeight) + 'px')
          }
        } else {
          mainImage.setAttribute('style', 'top: 0')
		  cmpParallaxMain.removeAttribute('style');
          _.component.setAttribute('style', 'margin-bottom: 0')
        }
      }
      window.addEventListener('resize', setSize, false)
      window.addEventListener('load', setSize, false)
      window.addEventListener('orientationchange', setSize, false)
    }
  }
}

export default cmpContactContent
